"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _client = require("@apollo/client");
//  https://github.com/apollographql/react-apollo/issues/3499#issuecomment-586039082
var useImperativeQuery = function useImperativeQuery(query) {
  var _useQuery = (0, _client.useQuery)(query, {
      skip: true
    }),
    refetch = _useQuery.refetch;
  var imperativelyCallQuery = (0, _react.useCallback)(function (variables) {
    return refetch(variables);
  }, [refetch]);
  return imperativelyCallQuery;
};
var _default = exports["default"] = useImperativeQuery;